import React from 'react';
import {UseFormRegister} from 'react-hook-form';

import FormGroup from 'shared/ui/FormGroup/FormGroup';
import PremiumCheckbox from 'shared/ui/Checkbox/PremiumCheckbox/PremiumCheckbox';
import useDomainMonitorChecks from 'features/domain/model/useDomainMonitorChecks';

import styles from './DomainMonitorChecks.module.scss';

interface IDomainMonitorChecksProps {
    register: UseFormRegister<any>,
    activeKeys?: string[],
}

const DomainMonitorChecks: React.FC<IDomainMonitorChecksProps> = ({register, activeKeys}) => {
    const checks = useDomainMonitorChecks(activeKeys);

    return (
        <div className={styles.checks}>
            {checks.map(check => (
                <FormGroup key={check.name} className={styles.checkRow}>
                    <PremiumCheckbox
                        label={check.label}
                        helpText={check.help}
                        register={register(check.name)}
                        enabled={check.enabled}
                    />
                </FormGroup>
            ))}
        </div>
    );
};

export default DomainMonitorChecks;
